import { useAuth } from '../lib/auth'
import { ExportDocs } from '../components/ExportDocs'
import { EmptyState, Spinner } from '../components/ui'

export function ExportPage() {
  const { staff, loading } = useAuth()

  return (
    <div className="mx-auto max-w-3xl px-1 py-10 lg:px-8">
      <h1 className="mb-2 text-2xl font-semibold tracking-tight text-ink">Export</h1>
      <p className="mb-8 text-sm text-muted">
        Take the documentation with you — to read offline, or to hand to an assistant.
      </p>

      {loading ? (
        <Spinner />
      ) : staff ? (
        <ExportDocs />
      ) : (
        <EmptyState title="Staff only">
          Exporting requires the employee, developer, admin or root role.
        </EmptyState>
      )}
    </div>
  )
}
